import { getNumericCssPropertyValue } from './stylesheet-utils';

export const scrollToBlock = (
  targetBlock,
  useTopMenuOffset = true,
  extraOffset = 0
) => {
  const topMenuHeight = getNumericCssPropertyValue('--header-height');

  if (targetBlock) {
    const offset = useTopMenuOffset ? topMenuHeight : 0;
    const offsetWithExtra = offset + extraOffset;

    const y =
      targetBlock.getBoundingClientRect().top +
      window.scrollY -
      offsetWithExtra;

    window.scrollTo({ top: y, behavior: 'smooth' });
  }
};
